import View from './View';
import useProps from './useProps';

const ByDayList = () => {
  const props = useProps();
  return <View {...props} />;
};

export default ByDayList;
